import React, { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../../App";
import Cards from "./Cards";
import { Segment, DropdownItemProps, Button, Icon, Grid, Modal, Confirm, Table, Pagination } from "semantic-ui-react";
import Page from "../../layout/Page";
import Filters from "./Filters";
import ClientRepository from "../../../common/repository/ClientRepository";
import RoleRepository from "../../../common/repository/RoleRespository";
import StateDistrictRepository from "../../../common/repository/StateDistrictRepository";
import UserRepository from "../../../common/repository/UserRepository";
import CaseRepository, { GetCaseCountRequestObject, } from "../../../common/repository/CaseRepository";
import CaseCategoryRepository from "../../../common/repository/CaseCategoryRepository";
import Result from "../../../common/repository/Result";
import { toast } from "../../common/Toast";
import HomePageContext from "./HomePageContext";
import constants from "../../../common/constants";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../../../redux";
import HospitalRepository from "../../../common/repository/HospitalRepository";
import CaseColumnRenderer from "../case/CaseListPage/CaseColumnRenderer";
import LocalStorage from "../../../lib/LocalStorage";
import axios from "axios";
import config from "../../../common/repository/config";
import StatesDistrictsRepository from "../../../common/repository/StatesDistrictsRepository";
import NotifecationRepo from "../../../common/repository/NotifecationRepo";
import { EFAULT } from "constants";
import Client from "../../../models/Client";
import CaseType from "../../../models/CaseType";

function HomePage() {
  interface MrdCountResponse {
    mrd_request: number;
    success: boolean;
    message: string | null;
    data: {
      items: number;
      total_item_count: number;
    };
  }
  interface DailyStatusCount {
    mrd_request: number;
    success: boolean;
    message: string | null;
    data: {
      items: number;
      total_item_count: number;
    };
  }
  interface Case {
    _id: string;
    claim_number: string;
    case_type_name: string;
    case_state: string;
    daily_status: {
      _id: string;
      service_type: string;
      service_status: string;
    }[];
  }
  interface AllocatorGroup {
    count: number;
    cases: Case[];
    allocator_id: string;
    allocator_name: string;
  }

  interface Case {
    _id: string;
    claim_number: string;
    case_type_name: string;
    case_state: string;
    daily_status: {
      _id: string;
      service_type: string;
      service_status: string;
    }[];

  }

  interface AllocatorGroup {
    count: number;
    cases: Case[];
    allocator_id: string;
    allocator_name: string;
  }
  interface CloseCaseCount {
    success: boolean;
    message: string | null;
    data: {
      total_item_count: number;
    };
  }

  interface InstructionCount {
    success: boolean;
    message: string | null;
    data: {
      total_item_count: number;
      items: any; // or null
    };
  }
  interface ApproveCountData {
    data: { total_item_count: number; };
  }
  const authState = useSelector((state: AppState) => state.auth);
  const dispatch = useDispatch();
  const user = authState.user;
  const history = useHistory();
  const clientRepo = new ClientRepository();
  const roleRepo = new RoleRepository();
  const caseCategoryRepo = new CaseCategoryRepository();
  const stateRepo = new StateDistrictRepository();
  const userRepo = new UserRepository();
  const caseRepo = new CaseRepository();
  const hospitalRepo = new HospitalRepository();
  const caseColumnRenderer = new CaseColumnRenderer();
  const notifecationRepo = new NotifecationRepo()
  const statesDistRepo = new StatesDistrictsRepository();
  const [loadingEssentialData, setLoadingEssentialData] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingCaseCount, setLoadingCaseCount] = useState(true);
  const [stateInitiatedCount, setStateInitiatedCount] = useState("-");
  const [stateGeneratedCount, setStateGeneratedCount] = useState("-");
  const [stateOpenCount, setStateOpenCount] = useState("-");
  const [stateReportWritingCount, setStateReportWritingCount] = useState("-");
  const [statePushbackCACount, setStatePushbackCACount] = useState("-");
  const [statePushbackRWCount, setStatePushbackRWCount] = useState("-");
  const [stateFoldCount, setStateFoldCount] = useState("-");
  const [stateCheckedCount, setStateCheckedCount] = useState("-");
  const [stateCloseCount, setStateCloseCount] = useState("-");
  const [stateGradedCount, setStateGradedCount] = useState("-");
  const [stateReinvestigateCount, setStateReinvestigateCount] = useState("-");

  const [stateInitiatedInstructionCount, setStateInitiatedInstructionCount] = useState("-");
  const [stateGeneratedInstructionCount, setStateGeneratedInstructionCount] = useState("-");
  const [stateOpenInstructionCount, setStateOpenInstructionCount] = useState("-");
  const [stateReportWritingInstructionCount, setStateReportWritingInstructionCount] = useState("-");
  const [statePushbackCAInstructionCount, setStatePushbackCAInstructionCount] = useState("-");
  const [statePushbackRWInstructionCount, setStatePushbackRWInstructionCount] = useState("-");
  const [stateFoldInstructionCount, setStateFoldInstructionCount] = useState("-");
  const [stateCheckedInstructionCount, setStateCheckedInstructionCount] = useState("-");
  const [stateCloseInstructionCount, setStateCloseInstructionCount] = useState("-");
  const [stateGradedInstructionCount, setStateGradedInstructionCount] = useState("-");
  const [stateReinvestigateInstructionCount, setStateReinvestigateInstructionCount] = useState("-");



  const [source, _] = useState(caseRepo.createSource());
  const [roleOptions, setRoleOptions] = useState<DropdownItemProps[]>([]);
  const [userOptions, setUserOptions] = useState<DropdownItemProps[]>([]);
  const [caseCategoryOptions, setCaseCategoryOptions] = useState<
    DropdownItemProps[]
  >([]);
  const [caseTypeOptions, setCaseTypeOptions] = useState<DropdownItemProps[]>([]);
  const [clients, setClients] = useState<Client[]>([]);
  const [clientCaseTypeLookup, setClientCaseTypeLookup] = useState<Record<string, DropdownItemProps[]>>({});
  const [clientOptions, setClientOptions] = useState<DropdownItemProps[]>([]);
  const [tpaOptions, setTpaOptions] = useState<DropdownItemProps[]>([]);
  const [stateOptions, setStateOptions] = useState<DropdownItemProps[]>([]);
  const [districtOptions, setDistrictOptions] = useState<DropdownItemProps[]>([]);
  const [AllDistrictS, setAllDistricts] = useState<DropdownItemProps[]>([])
  const [hospitalOptions, setHospitalOptions] = useState<DropdownItemProps[]>([]);
  const [searchFilter, setSearchFilter] = useState("");
  const [userRoleFilter, setUserRoleFilter] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [caseCategoryFilter, setCaseCategoryFilter] = useState("");
  const [caseStateFilter, setCaseStateFilter] = useState("");
  const [clientFilter, setClientFilter] = useState("");
  const [tpaFilter, setTpaFilter] = useState("");
  const [statesFilter, setStatesFilter] = useState("");
  const [districtFilter, setDistrictFilter] = useState("");

  const [claimNumberFilter, setClaimNumberFilter] = useState("");
  const [doctorNameFilter, setDoctorNameFilter] = useState("");
  const [hospitalFilter, setHospitalFilter] = useState("");
  const [hospitalSearch, setHospitalSearch] = useState("")
  const [caseTypeFilter, setCaseTypeFilter] = useState("");
  const [insuredNameFilter, setInsuredNameFilter] = useState("");
  const [fromFilter, setFromFilter] = useState("");
  const [toFilter, setToFilter] = useState("");
  const [getByClosedDate, setGetByClosedDate] = useState(false);
  const [defaultCaseCategory, setDefaultCaseCategory] = useState(true);
  const [getReinvestigation, setGetReinvestigation] = useState(false);
  const [getPushback, setPushback] = useState(false);
  // const [Counts, SetCounts] = useState<{ [key: string]: any }>({});
  const [showPopup, setShowPopup] = useState(false);
  const [loadingCaseCategory, setLoadingCaseCategory] = useState(false);
  const [caseCategory, setCaseCategory]: any[] = useState([]);
  const [caseCategoryCount, setCaseCategoryCount]: any[] = useState([])
  const [selectedCategoryIds, setSelectedCategoryIds]: any[] = useState([]);
  const [activeRibbon, setActiveRibbon] = useState<string | null>(null);
  const { Count, setCounts } = useContext<any>(GlobalContext)
  const [notificationData, setNotificationData] = useState<MrdCountResponse | null>(null);
  const [dailyStatusCount, setDailyStatusCount] = useState<DailyStatusCount | null>(null);
  const [reportStatusCount, setReportStatusCount] = useState<any>(null);
  const [dailyStatusPendingCount, setDailyStatusPendingCount] = useState<AllocatorGroup[]>([]);
  const [ClosedCases, setClosedCases] = useState<CloseCaseCount | null>(null);
  const [CountApprove, setCountApprove] = useState<ApproveCountData | null>(null);
  const [instructionCasesByState, setInstructionCasesByState] = useState<{ [state: string]: any[] }>({});

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [reportee, setReportee] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);

  // const [userId, setUserId] = useState("5edb4fd73d834976d9db7fc4");
  const [defaultCategoryId, setDefaultCategoryId] = useState<string[]>([]);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingCategoryId, setPendingCategoryId] = useState<any | null>(null);
  const [pendingCategoryTitle, setPendingCategoryTitle] = useState<string>('');
  const [tempDefaultIds, setTempDefaultIds] = useState<any[]>([]);
  const [instructionCount, setInstructionCount] = useState<InstructionCount | null>(null);

  const [successMessage, setSuccessMessage] = useState('');

  // Out-of-TAT modal state
  const [outOfTatModalOpen, setOutOfTatModalOpen] = useState<boolean>(false);
  const [outOfTatModalTitle, setOutOfTatModalTitle] = useState<string>("");
  const [outOfTatCases, setOutOfTatCases] = useState<any[]>([]);
  const [outOfTatPage, setOutOfTatPage] = useState<number>(1);

  const pageSize = 10;
  const totalOutOfTatPages = Math.max(1, Math.ceil((outOfTatCases?.length || 0) / pageSize));

  const openOutOfTatModal = (cat: any) => {
    try {
      const cases = cat?.getOutOfTatCases?.() || [];
      setOutOfTatCases(Array.isArray(cases) ? cases : []);
      setOutOfTatModalTitle(cat?.getName?.() || "Out-of-TAT Cases");
      setOutOfTatPage(1);
      setOutOfTatModalOpen(true);
    } catch (_) {
      setOutOfTatCases([]);
      setOutOfTatModalTitle("Out-of-TAT Cases");
      setOutOfTatPage(1);
      setOutOfTatModalOpen(true);
    }
  };

  const handleOpenCaseFromModal = async (c: any) => {
    const caseId = c?.id || c?._id || c?.case_id || c?.caseId;
    if (caseId) {
      window.open(`/case/view/${caseId}`);
      return;
    }
    const claimNumber = c?.claim_number || c?.claimNumber;
    if (!claimNumber) {
      toast.error('Unable to open case: missing id and claim number');
      return;
    }
    try {
      const result = await caseRepo.getCases({ claim_number: claimNumber });
      if (result instanceof Result.Success && result.data.items.length) {
        const item: any = result.data.items[0];
        const resolvedId = (typeof item.getId === 'function') ? item.getId() : (item?.id || item?._id);
        if (resolvedId) {
          window.open(`/case/view/${resolvedId}`);
          return;
        }
      }
      toast.error('Case not found for this claim number');
    } catch (e) {
      toast.error('Failed to resolve case by claim number');
    }
  };

  useEffect( () => {
    loadcasecategory();
    effectTriggerLoadCaseCount()
  }, [
    userFilter,
    defaultCaseCategory,
    caseCategoryFilter,
    caseTypeFilter,
    caseStateFilter,
    clientFilter,
    statesFilter,
    districtFilter,
    claimNumberFilter,
    hospitalFilter,
    insuredNameFilter,
    doctorNameFilter,
    fromFilter,
    toFilter,
    getByClosedDate,
    getReinvestigation,
    getPushback,
    searchFilter,
  ]);
  useEffect(() => {
    effectLoadCaseCount();
    loadcasecategory()
  }, [loadingCaseCount, loadingCaseCategory]);
  useEffect(() => {
    effectLoadEssentialData();

  }, [loadingEssentialData]);
  useEffect(() => {
    if (!clientFilter) {
      setCaseTypeOptions([]);
      if (caseTypeFilter) {
        setCaseTypeFilter("");
      }
      return;
    }

    const options = clientCaseTypeLookup[clientFilter] || [];
    setCaseTypeOptions(options);

    if (
      caseTypeFilter &&
      !options.some((option) => option.value === caseTypeFilter)
    ) {
      setCaseTypeFilter("");
    }
  }, [clientFilter, clientCaseTypeLookup]);
  useEffect(() => {
    effectLoadUsers();
  }, [userRoleFilter]);

  useEffect(() => {
    effectLoadDistrict()
  }, [statesFilter])
  useEffect(() => {
    GetCount()
  }, [])
  const refreshCount = async () => {
    localStorage.removeItem("caseCounts");
    localStorage.removeItem("caseFilters");
    setLoadingCaseCount(true);
    await effectLoadCaseCount();
  };
  const downloadData = async () => {
    let rs = createCountRequestObject();
    if (!rs) rs = {};
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    try {
      if (Object.entries(rs).length > 0) {
        toast.success("Download will start shortly!");
        let reqData = axios({
          url: config.apiBaseURL + `/case/export-excel`,
          method: "POST",
          responseType: "blob",
          data: rs,
          headers: { ["x-access-token"]: token },
        });
        reqData
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "casesData.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
          })
          .catch((e) => {
            toast.error("Something went wrong while downloading data!");
          });
      } else {
        toast.error("download feature not available yet!.");
      }
    } catch (e) {
      toast.error("Something went wrong while downloading");
    }
  };
 
  const loadcasecategory = async () => {
    setLoadingCaseCategory(true);
    if (userFilter.trim().length > 0) {
      const result = await caseCategoryRepo.getUserCategories({ userId: userFilter });
      if (result instanceof Result.Success) {
        const items = result.data.items;
        console.log(items,"userfiletercategory");
        const countObj: { [key: string]: number } = {};

        for (let category of result.data.items) {
          countObj[category.getName()] = category.getCasesCount()
        }

        setCaseCategory(items);
        setCaseCategoryCount(countObj);
      } else {
        const message = result.message || "Could not load CaseCategory";
        toast.error(message);
      }
    } else {
      const result = await caseCategoryRepo.getUserCategories({ userId: user?.getId() || "" });
      if (result instanceof Result.Success) {
        const items = result.data.items;
        console.log(items,"userfiletercategory");
        const countObj: { [key: string]: number } = {};

        for (let category of result.data.items) {
          countObj[category.getName()] = category.getCasesCount()
        }
        setCaseCategory(items);
        setCaseCategoryCount(countObj);
      } else {
        const message = result.message || "Could not load CaseCategory";
        toast.error(message);
      }
    }

  };
  useEffect(() => {
    const fetchMrdCount = async () => {
      setLoading(true);
      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) {
          setError('Authentication token is missing.');
          return;
        }
        const response = await fetch(`${config.apiBaseURL}/notification/countMrd`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
        });
        if (!response.ok) {
          throw new Error('Failed to fetch MRD count');
        }
        const data: MrdCountResponse = await response.json();
        setNotificationData(data);
      } catch (e) {
        console.log(e, "error");
      }
      finally {
        setLoading(false);
      }
    };
    fetchMrdCount();
  }, []);
  // Daily Status Count
  useEffect(() => {
    const fetchDailyStatusCount = async () => {
      setLoading(true);
      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) {
          setError('Authentication token is missing.');
          return;
        }
        const payload = { count: true };
        const response = await fetch(`${config.apiBaseURL}/notification/listDailyStatus`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          throw new Error('Failed to fetch daily status count');
        }
        const data: DailyStatusCount = await response.json();
        setDailyStatusCount(data);
      } catch (e) {
        console.log(e, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchDailyStatusCount();
  }, []);


  useEffect(() => {
    const fetchReportStatusCount = async () => {
      setLoading(true);
      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) {
          setError('Authentication token is missing.');
          return;
        }
        const payload = { count: true };
        const response = await fetch(`${config.apiBaseURL}/case/userReportStatus`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          if (response.status !== 404) throw new Error('Failed to fetch Report status count');
          setReportStatusCount(0);       
        }
        const data = await response.json();
        setReportStatusCount(data.data.items);
      } catch (e) {
        console.log(e, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchReportStatusCount();
  }, []);

  useEffect(() => {
    const fetchlistPendingStatus = async () => {
      setLoading(true);
      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) {
          setError('Authentication token is missing.');
          return;
        }

        const response = await fetch(`${config.apiBaseURL}/notification/listPendingStatus`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch daily status count');
        }

        const resData = await response.json();
        if (resData?.data?.items) {
          setDailyStatusPendingCount(resData.data.items);
        }
      } catch (e) {
        console.log(e, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchlistPendingStatus();
  }, []);



  useEffect(() => {
    const fetchCaseCloseCount = async () => {
      setLoading(true);
      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) {
          setError('Authentication token is missing.');
          return;
        }
        const response = await fetch(`${config.apiBaseURL}/notification/countFinishedInvestigation`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch MRD count');
        }
        const data: CloseCaseCount = await response.json();
        console.log(data);
        setClosedCases(data);
      } catch (e) {
        console.log(e, "error");
      }
      finally {
        setLoading(false);
      }
    };

    fetchCaseCloseCount();
  }, []);
  useEffect(() => {
    const fetchApproveCount = async () => {
      setLoading(true);
      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) {
          setError('Authentication token is missing.');
          return;
        }
        const response = await fetch(`${config.apiBaseURL}/notification/countRequestLogin`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch MRD count');
        }
        const data = await response.json();
        setCountApprove(data);
      } catch (e) {
        console.log(e, "error");
      }
      finally {
        setLoading(false);
      }
    };

    fetchApproveCount();
  }, []);
  useEffect(() => {
    const saved = localStorage.getItem("selectedCategoryIds");
    if (saved) {
      setSelectedCategoryIds(JSON.parse(saved));
    }
  }, []);
  useEffect(() => {
    const saved = localStorage.getItem("defaultcasecategoryId");
    if (saved) {
      setDefaultCategoryId(JSON.parse(saved));
    }
  }, []);
  useEffect(() => {
    const saved = localStorage.getItem("selectedCategoryIds");
    if (saved) {
      setSelectedCategoryIds(JSON.parse(saved));
    }
  }, []);
  useEffect(() => {
    localStorage.setItem("defaultcasecategoryId", JSON.stringify(defaultCategoryId));
  }, [defaultCategoryId]);
   const handleUpdate = async (categoryIds: any[]) => {
    setLoading(true);
    setError('');
    setSuccessMessage('');
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        setError('Authentication token is missing.');
        return;
      }

      const response = await fetch(`${config.apiBaseURL}/user/updateCaseCategory`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
        body: JSON.stringify({
          userId: user?.getId(),
          caseCategory: categoryIds,
        }),
      });

      const data = await response.json();
      refreshCount();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to update category');
      }

      const cateMessage = data.message || 'Category updated successfully!';
      setSuccessMessage(cateMessage);
      toast.success(`Category ${cateMessage}`);
    } catch (e) {
      setError((e as Error).message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };




  const handleDefaulyCategoryUpdate = async () => {
    setLoading(true);
    setError('');
    setSuccessMessage('');
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        setError('Authentication token is missing.');
        return;
      }
      const response = await fetch(`${config.apiBaseURL}/user/updateDefaultCaseCategory`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
        body: JSON.stringify({
          userId: user?.getId(),
          defaultCaseCategory: defaultCategoryId,
        }),
      });

      const data = await response.json();
      refreshCount();
      setSettingsOpen(false)
      if (!response.ok) {

        throw new Error(data.message || 'Failed to update category');
      }

      const cateMessage = data.message || ' Default Category updated successfully!';
      setSuccessMessage(cateMessage);
      toast.success(`Category ${cateMessage}`);

    } catch (e) {
      setError((e as Error).message || 'Something went wrong');
    }
    finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const fetchInstructionCount = async () => {
      setLoading(true);
      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) {
          setError('Authentication token is missing.');
          return;
        }
        const payload = { count: true };
        const response = await fetch(`${config.apiBaseURL}/notification/countInstruction`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          throw new Error('Failed to fetch daily status count');
        }
        const data: InstructionCount = await response.json();
        setInstructionCount(data);
      } catch (e) {
        console.log(e, "error");
      } finally {
        setLoading(false);
      }
    };
    fetchInstructionCount();
  }, []);


  const toggleCaseCategorySelection = (id: number) => {
    setSelectedCategoryIds((prev: number[]) =>
      prev.includes(id)
        ? prev.filter((catId: number) => catId !== id)
        : [...prev, id]
    );
  };

  var mrd_requestCount;
  async function GetCount() {
    const result = await notifecationRepo.getNotifectionCount();
    if (result instanceof Result.Success) {
      setCounts((obj: any) => {
        const countNotifications = ({ ...obj, ...result.data.items });
        mrd_requestCount = countNotifications.mrd_request;
        console.log(countNotifications,"countNotifications");
        console.log(typeof mrd_requestCount);
        return countNotifications;

      })

    } else {
      const message = result.message || "Could not load Count";
      toast.error(message);
    }
  }


  function handleDecline(): void {
    setShowPopup(false);

  }

  function handleApprove(): void {
    setShowPopup(false);

  }

  return (
    <>

      <HomePageContext.Provider
        value={{
          options: {
            category: caseCategoryOptions,
            caseType: caseTypeOptions,
            client: clientOptions,
            tpa:tpaOptions,
            states: stateOptions,
            districts: districtOptions,
            user: userOptions,
            userRoles: roleOptions,
            hospital: hospitalOptions,
          },
          filters: {
            AllDistrictS: AllDistrictS,
            reportee: reportee,
            setReportee: setReportee,
            setDistrictOptions: setDistrictOptions,
            defaultCaseCategory: defaultCaseCategory,
            setDefaultCaseCategory: setDefaultCaseCategory,
            category: caseCategoryFilter,
            setCategory: setCaseCategoryFilter,
            caseType: caseTypeFilter,
            setCaseType: setCaseTypeFilter,
            state: caseStateFilter,
            setState: setCaseStateFilter,
            client: clientFilter,
            setClient: setClientFilter,
            tpa:tpaFilter,
            setTpa:setTpaFilter,
            states: statesFilter,
            setStates: setStatesFilter,
            district: districtFilter,
            setDistrict: setDistrictFilter,
            user: userFilter,
            setUser: setUserFilter,
            userRole: userRoleFilter,
            setUserRole: setUserRoleFilter,
            search: searchFilter,
            setSearch: setSearchFilter,
            claimNumber: claimNumberFilter,
            setClaimNumber: setClaimNumberFilter,
            doctorName: doctorNameFilter,
            setDoctorName: setDoctorNameFilter,
            hospital: hospitalFilter,
            setHospital: setHospitalFilter,
            insuredName: insuredNameFilter,
            setInsuredName: setInsuredNameFilter,
            from: fromFilter,
            setFrom: setFromFilter,
            to: toFilter,
            setTo: setToFilter,
            getByClosedDate: getByClosedDate,
            setGetByClosedDate: setGetByClosedDate,
            getReinvestigation: getReinvestigation,
            setGetReinvestigation: setGetReinvestigation,
            getPushback: getPushback,
            setPushback: setPushback,
            onChange: onChange,
            setHospitalSearch: setHospitalSearch,
            hospitalSearch: hospitalSearch
          },
          count: {
            initiated: stateInitiatedCount,
            generated: stateGeneratedCount,
            open: stateOpenCount,
            reportwriting: stateReportWritingCount,
            pushbackCA: statePushbackCACount,
            pushbackRW: statePushbackRWCount,
            reinvestigate: stateReinvestigateCount,
            fold: stateFoldCount,
            checked: stateCheckedCount,
            close: stateCloseCount,
            graded: stateGradedCount,
          },
          intructionCount: {
            initiated: stateInitiatedInstructionCount,
            generated: stateGeneratedInstructionCount,
            open: stateOpenInstructionCount,
            reportwriting: stateReportWritingInstructionCount,
            pushbackCA: statePushbackCAInstructionCount,
            pushbackRW: statePushbackRWInstructionCount,
            reinvestigate: stateReinvestigateInstructionCount,
            fold: stateFoldInstructionCount,
            checked: stateCheckedInstructionCount,
            close: stateCloseInstructionCount,
            graded: stateGradedInstructionCount,

          },
          instructionCasesByState: instructionCasesByState,
          navigate: navigateToCaseList,
        }}
      >
        {/* {user?.getRole().getTitle() === constants.roleTitle.ca && ( */}
          <>

            <Segment>
              <div className="category-wrapper" style={{ padding: '10px' }}>
                <div
                  className="category-ribbons"
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                    gap: '10px',
                    marginBottom: '20px',
                  }}
                >
                  {/* Static "Default" card */}
                  <div
                  onClick={() => {
                    setTempDefaultIds(defaultCategoryId);
                    setPendingCategoryId('default');
                    setPendingCategoryTitle('Default Category');
                    setTimeout(() => setConfirmOpen(true), 0);
                  }}
                  
                    style={{
                      padding: '10px 15px',
                      borderLeft: '5px solid #2185d0',
                      backgroundColor: activeRibbon === 'default' ? '#e8f4fd' : '#f9f9f9',
                      cursor: 'pointer',
                      minWidth: '150px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                      borderRadius: '4px',

                    }}
                    title="Select Default Categories"
                  >
                    <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#333' }}>
                      Default
                    </div>
                    <div style={{ fontSize: '12px', color: '#777' }}>Select All Default</div>
                  </div>

                  {/* Confirm modal */}
                  <Confirm
                    open={confirmOpen}
                    content={
                      pendingCategoryId === 'all'
                        ? 'Are you sure you want to select all categories?'
                        : pendingCategoryId === 'default'
                          ? 'Are you sure you want to select the default category?'
                          : `Are you sure you want to select the category "${pendingCategoryTitle}"?`
                    }
                    onCancel={() => {
                      setConfirmOpen(false);
                      setPendingCategoryTitle('');
                    }}
                    onConfirm={() => {
                      let newSelectedIds: any[] = [];
                      if (pendingCategoryId === 'all') {
                        newSelectedIds = (caseCategory || []).map((cat: any) => cat.getId());
                        setActiveRibbon('all');
                      } else if (pendingCategoryId === 'default') {
                        newSelectedIds = [...defaultCategoryId];
                        setActiveRibbon('default');
                      } else if (pendingCategoryId !== null) {
                        newSelectedIds = [pendingCategoryId];
                        setActiveRibbon(pendingCategoryId);
                      }
                      console.log("Sending categoryIds to handleUpdate:", newSelectedIds); 
                      setSelectedCategoryIds(newSelectedIds);
                      handleUpdate(newSelectedIds);
                      setConfirmOpen(false);
                      setPendingCategoryId(null);
                      setPendingCategoryTitle('');
                    }}
                  />
                  {/*  Category Cards */}
   {caseCategory.map((cat: any, index: any) => {
                  const isSelected = selectedCategoryIds.includes(cat.getId());
                  const isDefault = (defaultCategoryId || []).includes(cat.getId());
                  return (
                    <>
                      <div
                        key={cat.getId()}
                        onClick={() => {
                          setPendingCategoryId(cat.getId());
                          setPendingCategoryTitle(cat.getName());
                          setTimeout(() => setConfirmOpen(true), 0);
                        }}
                        style={{
                          padding: '10px 15px',
                          borderLeft: '5px solid',
                          borderColor:
                            activeRibbon === cat.getId()
                              ? '#2185d0'
                              : index % 2 === 0
                                ? '#f2711c'
                                : '#2185d0',

                          backgroundColor:
                            activeRibbon === cat.getId()
                              ? '#F9F9F9'
                              : index % 2 === 0
                                ? '#F9F9F9'
                                : '#F9F9F9',
                        }}

                        title={isDefault ? 'Default category' : ''}
                      >
                        <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#333' }}>
                          {cat.getName()}
                          {cat.getOutOfTatCases() && (
                            <span
                              className="head-bell"
                              onClick={(e) => {
                                e.stopPropagation();
                                openOutOfTatModal(cat);
                              }}
                              title="View Out-of-TAT cases"
                              style={{ cursor: 'pointer' }}
                            >
                              <span className="bell-badge-categoryCount">
                                {cat.getOutOfTatCount()}
                              </span>
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: '12px', color: '#777' }}>
                          Count: {caseCategoryCount?.[cat.getName()] ?? 0}
                        </div>
                      </div>
                    </>

                  );
                })}


                  {/* Static "All" card */}
                  <div
                    onClick={() => {
                      setPendingCategoryId('all');
                      setPendingCategoryTitle('All Categories');
                      setTimeout(() => setConfirmOpen(true), 0);
                    }}
                    style={{
                      padding: '10px 15px',
                      borderLeft: '5px solid #2185d0',
                      backgroundColor: activeRibbon === 'all' ? '#e8f4fd' : '#f9f9f9',
                      cursor: 'pointer',
                      minWidth: '150px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                      borderRadius: '4px',
                    }}
                    title="All Categories"
                  >
                    <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#333' }}>
                      All
                    </div>
                    <div style={{ fontSize: '12px', color: '#777' }}>Select All Categories</div>
                  </div>

                  {/* Settings icon */}
                  <div
                    className="category-header"
                    style={{
                      marginLeft: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Icon
                      name="settings"
                      size="large"
                      link
                      onClick={() => setSettingsOpen(true)}
                      title="Set Default Category"
                    />
                  </div>
                </div>
              </div>
            </Segment>

            {/* Settings Modal for Default Category */}
            <Modal open={settingsOpen} onClose={() => setSettingsOpen(false)} size="tiny">
              <Modal.Header>Select Default Category</Modal.Header>
              <Modal.Content>
                <div
                  className="category-container"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
                    gap: '10px',
                    padding: '10px',
                  }}
                >
                  {caseCategory.map((cat: any) => {
                    const isSelected = defaultCategoryId.includes(cat.getId());
                    const isDefault = defaultCategoryId.includes(cat.getId());

                    return (
                      <div
                        key={cat.getId()}
                        onClick={() => {
                          setDefaultCategoryId((prev) =>
                            prev.includes(cat.getId())
                              ? prev.filter((id) => id !== cat.getId())
                              : [...prev, cat.getId()]
                          );
                        }}
                        style={{
                          padding: '10px 15px',
                          borderLeft: '5px solid',
                          borderColor: isSelected
                            ? defaultCategoryId.indexOf(cat.getId()) % 2 === 0
                              ? '#f2711c'
                              : '#2185d0'
                            : '#ccc',
                          backgroundColor: isSelected ? '#e8f4fd' : '#f9f9f9',
                          cursor: 'pointer',
                          minWidth: '150px',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                          borderRadius: '4px',
                        }}
                        title={isSelected ? 'Default selected' : 'Click to select'}
                      >
                        <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{cat.getName()}</div>
                        {/* ID shown for reference if needed */}
                        {/* <div style={{ fontSize: '12px', color: '#777' }}>{cat.getCode()}</div> */}
                      </div>
                    );
                  })}
                </div>
              </Modal.Content>
              <Modal.Actions>
                <Button onClick={() => setSettingsOpen(false)}>Cancel</Button>
                <Button
                  primary
                  disabled={defaultCategoryId.length === 0}
                  onClick={handleDefaulyCategoryUpdate}
                >
                  Save Default
                </Button>
              </Modal.Actions>
            </Modal>

            {/* Out-of-TAT Cases Modal */}
            <Modal open={outOfTatModalOpen} onClose={() => setOutOfTatModalOpen(false)} size="small">
              <Modal.Header>{outOfTatModalTitle} - Out-of-TAT Cases</Modal.Header>
              <Modal.Content>
                {outOfTatCases?.length ? (
                  <>
                    <Table celled compact selectable>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell width={10}>Claim Number</Table.HeaderCell>
                          <Table.HeaderCell width={6} textAlign="right">Action</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {(outOfTatCases
                          .slice((outOfTatPage - 1) * pageSize, outOfTatPage * pageSize) || [])
                          .map((c: any, idx: number) => (
                            <Table.Row key={(c?.id || c?._id || c?.case_id || idx).toString()}>
                              <Table.Cell>{c?.claim_number || c?.claimNumber || '-'}</Table.Cell>
                              <Table.Cell textAlign="right">
                                <Button size="small" primary onClick={() => handleOpenCaseFromModal(c)}>Open</Button>
                              </Table.Cell>
                            </Table.Row>
                          ))}
                      </Table.Body>
                    </Table>
                    {totalOutOfTatPages > 1 && (
                      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                        <Pagination
                          activePage={outOfTatPage}
                          totalPages={totalOutOfTatPages}
                          onPageChange={(e, data) => setOutOfTatPage(Number(data.activePage))}
                          firstItem={null}
                          lastItem={null}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div>No Out-of-TAT cases found.</div>
                )}
              </Modal.Content>
              <Modal.Actions>
                <Button onClick={() => setOutOfTatModalOpen(false)}>Close</Button>
              </Modal.Actions>
            </Modal>

          </>
        {/* )} */}
        <Button
          style={{
            float: "right",
            marginTop: "20px",
            marginRight: "10px",
            backgroundColor: "rgb(18," + " 33, 214)",
            color: "white",
          }}
          animated
          onClick={async () => await refreshCount()}
        >
          <Button.Content visible>Refresh</Button.Content>
          <Button.Content hidden>
            <Icon name="refresh" />
          </Button.Content>
        </Button>
        {/* <Page title={"Dashboard"}> */}

          <Grid >
            <Grid.Column floated='left' width={4}>
              <button className="ui blue button" onClick={downloadData}>
                Export as Excel
              </button>
            </Grid.Column>

            <Grid.Column textAlign='right' floated='right' width={12}>
            {user?.getRole().getTitle() !== constants.roleTitle.ca && <> <span className="head-bell">
                {/* <button className="ui blue button" onClick={() => naviugateToNotifications("mrd")}>
                  MRD
                </button> */}
                {/* {Count?.mrd_request > 0 && (
                  <span className="bell-badge">
                    {Count.mrd_request <= 99 ? Count.mrd_request : "99+"}
                  </span>
                )} */}
              </span>
            </>}

              {user?.getRole().getTitle() === constants.roleTitle.ao && constants.roleTitle.tl && (
                <>
                  <span className="head-bell">
                    <button
                      className="ui blue button"
                      onClick={() => naviugateCloseCases("closecase")}
                    >
                      Fo Closures
                    </button>
                    {ClosedCases?.data?.total_item_count !== undefined && (
                      <span className="bell-badge">
                        {ClosedCases.data.total_item_count === 0
                          ? "0"
                          : ClosedCases.data.total_item_count > 999
                            ? "99+"
                            : ClosedCases.data.total_item_count}
                      </span>
                    )}
                  </span>

                  <span className="head-bell">
                    <button
                      className="ui blue button"
                      onClick={() => naviugateloginRequest("closecase")}
                    >
                      Login Request
                    </button>
                    {CountApprove?.data?.total_item_count !== undefined && (
                      <span className="bell-badge">
                        {CountApprove.data.total_item_count === 0
                          ? "0"
                          : CountApprove.data.total_item_count > 999
                            ? "99+"
                            : CountApprove.data.total_item_count}
                      </span>
                    )}
                  </span>
                </>
              )}
              {user?.getRole().getTitle() !== constants.roleTitle.ca && (
                <>
                  <span className="head-bell"><button className="ui blue button" onClick={() => naviugateToNotifications("mrd")}> MRD </button>
                    {notificationData?.data?.total_item_count !== undefined && (<span className="bell-badge">{notificationData.data.total_item_count === 0 ? "0" : notificationData.data.total_item_count > 99 ? "99+" :
                      notificationData.data.total_item_count}</span>)}</span></>)}

              <span className="head-bell">
                <button
                  className="ui blue button"
                  onClick={() => dailyStatusList("closecase")}
                >
                  Daily Status
                </button>
                {dailyStatusCount?.data?.items !== undefined && (
                  <span className="bell-badge">
                    {dailyStatusCount.data.items === 0
                      ? "0"
                      : dailyStatusCount.data.items > 999
                        ? "99+"
                        : dailyStatusCount.data.items}
                  </span>
                )}
              </span>

              <span className="head-bell">
                <button
                  className="ui blue button"
                  onClick={() => generationReportStatusList("reportStatus")}
                >
                      Report Generation status
                </button>
                {reportStatusCount  &&  (
                  <span className="bell-badge">
                    {reportStatusCount > 999 ? "99+" : reportStatusCount}
                  </span>
                )}
              </span>
              {(
                user?.getRole().getTitle() === constants.roleTitle.ceo ||
                user?.getRole().getTitle() === constants.roleTitle.md ||
                user?.getRole().getTitle() === constants.roleTitle.oh ||
                user?.getRole().getTitle() === constants.roleTitle.zo
              ) && (
                  <span className="head-bell">
                    <button
                      className="ui blue button"
                      onClick={() => dailyStatusPendingList("closecase")}
                    >
                      Daily Status Pending
                    </button>
                    {dailyStatusPendingCount.length > 0 && (
                      <span className="bell-badge">
                        {dailyStatusPendingCount.length > 999 ? "99+" : dailyStatusPendingCount.length}
                      </span>
                    )}
                  </span>
                )}
                <span className="head-bell">
                    <button
                      className="ui blue button"
                      onClick={() => instructionList("closecase")}
                    >
                      Instruction List
                    </button>
                    {instructionCount?.data?.total_item_count !== undefined &&
                      instructionCount.data.total_item_count > 0 && (
                        <span className="bell-badge">
                          {instructionCount.data.total_item_count > 999 ? "99+" : instructionCount.data.total_item_count}
                        </span>
                      )}
                  </span>   


            </Grid.Column>
            <Grid.Column textAlign='right' floated='right' width={12} >
              {user?.getRole().getTitle() === constants.roleTitle.ao && <> <span className="head-bell">
                <button className="ui blue button " onClick={() => navigateToOutstationExpense("lodging_expenses_request")}> Lodging expense & Outlocation</button>
                {Count?.lodging_expenses_request > 0 && <span className="bell-badge" >{Count?.lodging_expenses_request <= 99 ? Count?.lodging_expenses_request : "99+"}</span>}
              </span>
                <span className="head-bell">
                  <button className="ui blue button " onClick={() => naviugateToNotification("location_change_request")}>Location Change</button>
                  {Count.location_change_request > 0 && <span className="bell-badge" >{Count?.location_change_request <= 99 ? Count?.location_change_request : "99+"}</span>}
                </span>
                <span className="head-bell">
                  <button className="ui blue button " onClick={() => naviugateToNotification("mrd_request")}>MRD Charges </button>
                  {Count.mrd_request > 0 && <span className="bell-badge" >{Count?.mrd_request <= 99 ? Count?.mrd_request : "99+"}</span>}
                </span>
                <span className="head-bell">
                  <button className="ui blue button " onClick={() => naviugateToNotification("leave_applied")}>Leaves</button>
                  {Count.leave_applied > 0 && <span className="bell-badge" >{Count?.leave_applied <= 99 ? Count?.leave_applied : "99+"}</span>}
                </span>
                <span className="head-bell">
                  <button style={{ margin: "5px" }} className="ui blue button" onClick={() => naviugateToNotification("cancel_case")}>Case Cancelled by investigator</button>
                  {Count.cancel_case > 0 && <span className="bell-badge" >{Count?.cancel_case <= 99 ? Count?.cancel_case : "99+"}</span>}
                </span>
                <span className="head-bell">
                  <button style={{ margin: "5px" }} className="ui blue button" onClick={() => naviugateToNotification("no_work")}>No Work</button>
                  {Count.no_work > 0 && <span className="bell-badge" >{Count?.no_work <= 99 ? Count?.no_work : "99+"}</span>}
                </span>
              </>}
              {user?.getRole().getTitle() === constants.roleTitle.ca && <> <span className="head-bell">
                <button className="ui blue button " onClick={() => naviugateToNotification("case_start")}>Case Start</button>
                {Count.case_start > 0 && <span className="bell-badge" >{Count?.case_start <= 99 ? Count?.case_start : "99+"}</span>}
              </span>
                <span className="head-bell">
                  <button className="ui blue button " onClick={() => naviugateToNotification("close_investigation")}>close Investigation</button>
                  {Count.close_investigation > 0 && <span className="bell-badge" >{Count?.close_investigation <= 99 ? Count?.close_investigation : "99+"}</span>}
                </span>
                <span className="head-bell">
                  <button className="ui blue button " onClick={() => naviugateToNotification("case_close")}>Case Close</button>
                  {Count.case_close > 0 && <span className="bell-badge" >{Count?.case_close <= 99 ? Count?.case_close : "99+"}</span>}
                </span>
              </>}
            </Grid.Column>
          </Grid>
          <Segment style={{ width: "90%", margin: "10px auto" }}>
            <Filters />
          </Segment>
          <Segment loading={loadingCaseCount} style={{ width: "90%", margin: "0 auto" }}>
            {/* <Cards instructionCount = {}/> */}
            <Cards />
          </Segment>
        {/* </Page> */}
      </HomePageContext.Provider>
    </>
  );

  function effectTriggerLoadCaseCount() {
    setLoadingCaseCount(true);
    source.cancel();
  }

  async function effectLoadCaseCount() {
    if (!loadingCaseCount) return;
    const ro = createCountRequestObject();
    if (!localStorage.getItem("caseCounts")) {
      const result = await caseRepo.getCaseCount(ro, source.token);

      if (result instanceof Result.Success) {
        const items = result.data.items;
        console.log(items,"caseCount");
        let countItems: { key: string; value: number }[] = [];
        const instructionMap: { [state: string]: any[] } = {};
        items.forEach((it) => {
          countItems.push({ key: it.getState(), value: it.getCount() });
          try {
            // @ts-ignore
            const cases = typeof it.getCaseInstruction === 'function' ? it.getCaseInstruction() || [] : [];
            instructionMap[it.getState()] = cases;
          } catch (_) {
            instructionMap[it.getState()] = [];
          }
          if (it.getState() === constants.caseStates.initiated) {
            setStateInitiatedCount(it.getCount().toString()); 
            setStateInitiatedInstructionCount(it.getCasesWithInstructions().toString());
          } 
          else if (it.getState() === constants.caseStates.generated) {
            setStateGeneratedInstructionCount(it.getCasesWithInstructions().toString());
            setStateGeneratedCount(it.getCount().toString());
          }
          else if (it.getState() === constants.caseStates.open) {
            setStateOpenCount(it.getCount().toString());
            setStateOpenInstructionCount(it.getCasesWithInstructions().toString());
          }

          else if (it.getState() === constants.caseStates.report) {
            setStateReportWritingCount(it.getCount().toString());
            setStateReportWritingInstructionCount(it.getCasesWithInstructions().toString());
          }

          else if (it.getState() === constants.caseStates.pushbackCA) {
            setStatePushbackCACount(it.getCount().toString());
            setStatePushbackCAInstructionCount(it.getCasesWithInstructions().toString());
          }

          else if (it.getState() === constants.caseStates.pushbackRW) {
            setStatePushbackRWCount(it.getCount().toString());
            setStatePushbackRWInstructionCount(it.getCasesWithInstructions().toString());
          }

          else if (it.getState() === constants.caseStates.fold) {
            setStateFoldCount(it.getCount().toString());
            setStateFoldInstructionCount(it.getCasesWithInstructions().toString());
          }

          else if (it.getState() === constants.caseStates.checked) {
            setStateCheckedCount(it.getCount().toString());
            setStateCheckedInstructionCount(it.getCasesWithInstructions().toString());
          }

          else if (it.getState() === constants.caseStates.close) {
            setStateCloseCount(it.getCount().toString());
            setStateCloseInstructionCount(it.getCasesWithInstructions().toString());
          }

          else if (it.getState() === constants.caseStates.graded) {
            setStateGradedCount(it.getCount().toString());
            setStateGradedInstructionCount(it.getCasesWithInstructions().toString());
          }

          else if (it.getState() === constants.caseStates.reinvestigate) {
            setStateReinvestigateCount(it.getCount().toString());
            setStateReinvestigateInstructionCount(it.getCasesWithInstructions().toString());
          }

        });
        setInstructionCasesByState(instructionMap);
        localStorage.setItem("caseCounts", JSON.stringify(countItems));
      } else {
        const message = result.message || "Could not load Case Count";
        toast.error(message);
      }
    } else {
      let items = JSON.parse(localStorage.getItem("caseCounts")!);
      items.forEach((it: { key: string; value: string }) => {
        if (it.key === constants.caseStates.initiated)
          setStateInitiatedCount(it.value);
        else if (it.key === constants.caseStates.generated)
          setStateGeneratedCount(it.value);
        else if (it.key === constants.caseStates.open)
          setStateOpenCount(it.value);
        else if (it.key === constants.caseStates.report)
          setStateReportWritingCount(it.value);
        else if (it.key === constants.caseStates.pushbackCA)
          setStatePushbackCACount(it.value);
        else if (it.key === constants.caseStates.pushbackRW)
          setStatePushbackRWCount(it.value);
        else if (it.key === constants.caseStates.fold)
          setStateFoldCount(it.value);
        else if (it.key === constants.caseStates.checked)
          setStateCheckedCount(it.value);
        else if (it.key === constants.caseStates.close)
          setStateCloseCount(it.value);
        else if (it.key === constants.caseStates.graded)
          setStateGradedCount(it.value);
        else if (it.key === constants.caseStates.reinvestigate)
          setStateReinvestigateCount(it.value);
      });
    }
    setLoadingCaseCount(false);
  }


  function createCountRequestObject() {
    const ro: GetCaseCountRequestObject = {
      showByState: true,
    };
    //
    if (userFilter.trim().length !== 0 && userRoleFilter.trim().length !== 0)
      ro.user = { id: userFilter, role: userRoleFilter, reportee:reportee };
    if (caseCategoryFilter.trim().length !== 0)
      ro.case_category = caseCategoryFilter;
    if (caseTypeFilter.trim().length !== 0) ro.case_type_id = caseTypeFilter;
    if (caseStateFilter.trim().length !== 0) ro.state = caseStateFilter;
    if (clientFilter.trim().length !== 0) ro.client_id = clientFilter;

    if (statesFilter.trim().length !== 0) ro.location = { state: statesFilter }
    if (districtFilter.trim().length !== 0) statesFilter ? ro.location = { state: statesFilter, district: districtFilter } :
      ro.location = JSON.parse(districtFilter);
    if (claimNumberFilter.trim().length !== 0)
      ro.claim_number = claimNumberFilter;
    if (hospitalFilter.trim().length !== 0) ro.hospital_id = hospitalFilter;
    if (insuredNameFilter.trim().length !== 0)
      ro.insured_name = insuredNameFilter;
    if (doctorNameFilter.trim().length !== 0) ro.doctor_name = doctorNameFilter;
    if (fromFilter.trim().length !== 0) ro.from = fromFilter;
    if (toFilter.trim().length !== 0) ro.to = toFilter;
    if (searchFilter.trim().length !== 0) ro.search = searchFilter;
    if (getByClosedDate == true) ro.get_by_closed_date = true;
    if (getReinvestigation == true) ro.reinvestigation = true;
    if (getPushback == true) ro.pushback = true;


    if (Object.keys(ro).length >= 2) localStorage.removeItem("caseCounts");
    ///
    return ro;
  }

  async function effectLoadEssentialData() {
    if (!loadingEssentialData) return;

    const rolesPromise = roleRepo.getRoles({
      level_greater_than: user?.getRole().getLevel(),
    });
    const categoriesPromise = caseCategoryRepo.getCategories();
    const clientsPromise = clientRepo.getClients();
    const districtsPromise = stateRepo.getAll();
    const statesPromise = statesDistRepo.getStates();

    const [
      rolesResult,
      categoriesResult,
      clientsResult,
      districtsResult,
      statesResult,
    ] = await Promise.all([
      rolesPromise,
      categoriesPromise,
      clientsPromise,
      districtsPromise,
      statesPromise,
    ]);

    if (rolesResult instanceof Result.Success) {
      const rolesData = rolesResult.data.items.map((it) => {
        const reporteeData = it.getReportee(); 
        const roleTitle = String(it.getTitle());  
    
        let formattedReportee: string[] = [];
    
        if (Array.isArray(reporteeData)) {
          formattedReportee = Array.from(new Set(reporteeData.filter((item) => item))); 
        } else if (typeof reporteeData === "string") {
          formattedReportee = [reporteeData];
        }
    
        return {
          text: roleTitle,
          value: roleTitle,
          key: it.getId(),
          reportee: formattedReportee, 
        };
      });
      setRoleOptions(rolesData);
    }
     else {
      const message = rolesResult.message || "Could not load User Roles";
      toast.error(message);
    }

   if (categoriesResult instanceof Result.Success) {
      setCaseCategoryOptions(
        categoriesResult.data.items
          .filter((it) => it.getActivated() === false)
          .map((it) => ({
            text: it.getTitle(),
            value: it.getCode(),
            key: it.getCode(),
          }))
      );
    } else {
      const message = categoriesResult.message || "Could not load Case Categories";
      toast.error(message);
    }  

    if (clientsResult instanceof Result.Success) {
      const clientItems = clientsResult.data.items;
      setClients(clientItems);
      setClientOptions(
        clientItems.map((it) => ({
          text: `${it.getName()} ${it.getType() === 'Tpa' ? "(tpa)":""}`,
          value: it.getId(),
          key: it.getId(),
        }))
      );
      const lookup: Record<string, DropdownItemProps[]> = {};
      clientItems.forEach((client) => {
        if (typeof client?.getCaseTypes !== "function") return;
        const activeCaseTypeOptions = (client.getCaseTypes() || [])
          .filter((caseType: CaseType) => caseType.getActive())
          .map((caseType) => ({
            text: caseType.getTitle(),
            value: caseType.getId(),
            key: `${client.getId()}-${caseType.getId()}`,
          }));
        if (activeCaseTypeOptions.length > 0) {
          lookup[client.getId()] = activeCaseTypeOptions;
        }
      });
      setClientCaseTypeLookup(lookup);
      setCaseTypeOptions(clientFilter ? lookup[clientFilter] || [] : []);
    } else {
      const message = clientsResult.message || "Could not load Clients";
      toast.error(message);
    }

    if (statesResult instanceof Result.Success) {
      setStateOptions(
        statesResult.data.items.map((it) => ({
          text: it.getName(),
          value: it.getName(),
          key: it.getId(),
        }))
      );
    } else {
      const message = statesResult.message || "Could not load State";
      toast.error(message);
    }

    if (districtsResult instanceof Result.Success) {
      const districtOptions = districtsResult.data.items.map((it, i) => ({
        text: `${it.getDistrict()}, ${it.getState()}`,
        value: JSON.stringify({
          state: it.getState(),
          district: it.getDistrict(),
        }),
        key: i.toString(),
      }));
      
      setDistrictOptions(districtOptions);
      setAllDistricts(districtOptions);
    } else {
      const message = districtsResult.message || "Could not load Districts";
      toast.error(message);
    }
  
    setLoadingEssentialData(false);
  }


  async function effectLoadUsers() {
    console.log(userRoleFilter, "userRoleFilter")
    if (userRoleFilter.length === 0) return;
    let filter = { role: userRoleFilter, findTeam: false, is_active: true };
    if (
      userRoleFilter == constants.roleTitle.ca ||
      userRoleFilter == constants.roleTitle.tl ||
      userRoleFilter == constants.roleTitle.oh
    )
      filter.findTeam = true;
    const result = await userRepo.getUsers(filter);
    // const result = await userRepo.getUsersByRoleTitle({ role: userRoleFilter })
    if (result instanceof Result.Success) {
      setUserOptions(
        result.data.items.map((it) => ({
          text: it.getName(),
          value: it.getId(),
          key: it.getId(),
        }))
      );
    } else {
      const message = result.message || "Could not load Users";
      toast.error(message);
    }
  }
  // District Function
  async function effectLoadDistrict() {
    if (statesFilter.length === 0) return;
    let filter = { state: statesFilter };

    const result = await statesDistRepo.getDistricts(filter);
    if (result instanceof Result.Success) {
      setDistrictOptions(
        result.data.items.map((it, i) => ({
          text: it,
          value: it,
          key: i.toString(),
        }))
      );
    } else {
      const message = result.message || "Could not load District";
      toast.error(message);
    }
  }
  //  get Hospital
  async function effectLoadHospital(value: any) {
    // if (hospitalFilter.length === 0) return;
    let filter = { search: value };

    const result = await hospitalRepo.getHospitals(filter);
    if (result instanceof Result.Success) {
      setHospitalOptions(
        result.data.items.map((it, i) => ({
          text: it.getName(),
          value: it.getId(),
          key: it.getId(),
        }))
      );
    } else {
      const message = result.message || "Could not load hospital";
      toast.error(message);
    }
  }


  async function onChange(e: any) {

    const value = e.target.value;

    if (value.length > 2) {
      setHospitalSearch(value);
      await effectLoadHospital(value);
    } else {
      setHospitalSearch("");
    }
  }
  function naviugateToNotification(type: string) {
    history.push({
      pathname: "/notification",
      state: {
        type: type
      },
    });
  }
  function navigateToOutstationExpense(type: string) {
    history.push({
      pathname: "/OutstationExpense",
      state: {
        type: type
      }
    })
  }

  function naviugateToNotifications(type: string) {
    history.push({
      pathname: "/MrdNotifiction",
      state: {
        type: type
      },
    });
  }
  function naviugateCloseCases(type: string) {
    history.push({
      pathname: "/listFinishedInvestigation",
      state: {
        type: type
      },
    });
  }
  function naviugateloginRequest(type: string) {
    history.push({
      pathname: "/LoginRequest",
      state: {
        type: type
      },
    });
  }
  function dailyStatusList(type: string) {
    history.push({
      pathname: "/dailystatuslist",
      // state: {
      //   type: type
      // },
    });
  }

  function dailyStatusPendingList(type: string) {
    history.push({
      pathname: "/dailyStatusPendingList",
      // state: {
      //   type: type
      // },
    });
  }

  function generationReportStatusList(type?: string) {
    history.push({
      pathname: "/reportStatusList",
      // state: {
      //   type: type
      // },
    });
  }

  function instructionList(type: string) {
    history.push({
      pathname: "/instruction-list",
      // state: {
      //   type: type
      // },
    });
  }

  function navigateToCaseList(state: string) {
    // Always include caseTypeId when it's set, regardless of the state being navigated to
    // This ensures that filters applied on homepage are preserved when clicking bucket counts
    history.push({
      pathname: "/case/list",
      state: {
        caseCategoryCode: caseCategoryFilter,
        caseState: state,
        userId: userFilter,
        roleTitle: userRoleFilter,
        clientId: clientFilter,
        caseTypeId: caseTypeFilter, // Always include caseTypeId to preserve filter
        states: statesFilter,
        district: districtFilter,
        search: searchFilter,
        hospitalId: hospitalFilter,
        claimNumber: claimNumberFilter,
        insuredName: insuredNameFilter,
        doctorName: doctorNameFilter,
        from: fromFilter,
        to: toFilter,
        reinvestigation: getReinvestigation,
        pushback: getPushback
      },
    });
  }
}

export default HomePage;
